import axios from 'axios';
import create from 'zustand';
import { getUserDetails } from '../Auth/AuthUtil';
import { shopModel } from '../Axios/AxiosConfig';
import { encryptBody } from '../Axios/Middleware';

const useAddressStore = create((set) => ({
    addresses: [],
    currentAddress: null,

    addAddress: async (newAddress, navigate) => {
        try {


            let response = await shopModel.post(`/api/v1/address`, encryptBody({...newAddress }, { includeIv: false }));

            if (response && response?.status === 200) {

                set({
                    addresses: response?.data?.addresses,
                    currentAddress: newAddress
                })

                if (navigate) navigate('/Checkout');
            }

        }
        catch (err) {
            console.log(err?.response?.data);
        }
    },

    deleteAddress: async (id) => {
        try {
            let response = await shopModel.delete(`/api/v1/address/${id}`)
            if (response?.status === 200) {
                set((state) => ({
                    addresses: state.addresses.filter((address) => address.id !== id),
                }))
            }
        }
        catch (err) {
            console.log(err?.response?.data);
        }
    },

    editAddress: async (id, updatedAddress) => {
        try {
            let response = await shopModel.patch(`/api/v1/address/${id}`, encryptBody({ ...updatedAddress }, { includeIv: false }));
            if (response && response?.status === 200) {
                set({
                    addresses: response?.data?.addresses
                })
            }

        }
        catch (err) {
            console.log(err?.response?.data);
        }
    },

    setCurrentAddress: (item) => {
        set({ currentAddress: item })
    },

    getAddress: async () => {
        try {
            let response = await shopModel.get(`/api/v1/address`)

            if (response && response?.status === 200) {
                set({
                    addresses: response?.data?.addresses || [],
                    currentAddress: response?.data?.currentAddress || null
                })
            }
        }
        catch (err) {
            console.log(err?.response?.data);
        }
    },
}));

export default useAddressStore;
